import { type FileTypeEnum, uploadImageMediaUploadPost } from '@/shared/api/intranet'

export const uploadImage = async (file: File, type: FileTypeEnum) => {
  const formData = new FormData()
  formData.append('file', file)

  const { data, error } = await uploadImageMediaUploadPost({
    body: {
      file,
      file_type: type,
    },
  })
  if (error) {
    throw error
  }

  return data
}
